/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { Btn } from 'components/buttons'
import styled from '@emotion/styled'

const StyledBtn = styled(Btn)`
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;

  svg {
    margin-right: 0;
  }
`

const IconBtn = props => (
  <StyledBtn {...props} appearance='tertiary' block={false} />
)

IconBtn.propTypes = {
  /** String name for Icon you want rendered */
  Icon: PropTypes.func.isRequired,
  ref: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
}

export default IconBtn
